import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { BookOpenIcon, AlertTriangleIcon, FileTextIcon, SearchIcon, MapIcon } from 'lucide-react';
const deliverables = [{
  icon: BookOpenIcon,
  title: 'El eBook completo',
  description: 'Rescate de Pareja Post-Crisis (Guía de Supervivencia)',
  benefit: '→ Paz mental y claridad',
  value: '$4.500'
}, {
  icon: AlertTriangleIcon,
  title: 'Plan S.O.S de Emergencia',
  description: 'La palabra clave para frenar peleas antes de los gritos',
  benefit: '→ Acuerdos sin peleas',
  value: '$2.500'
}, {
  icon: FileTextIcon,
  title: 'El Contrato de Convivencia en Crisis',
  description: 'Plantilla descargable para completar y firmar',
  benefit: '→ Reglas claras, menos conflictos',
  value: '$3.500'
}, {
  icon: SearchIcon,
  title: 'Guía de "Auditoría de Resentimientos"',
  description: 'Para vaciar la mochila de facturas viejas',
  benefit: '→ Soltar el resentimiento acumulado',
  value: '$2.000'
}, {
  icon: MapIcon,
  title: 'Mapa de "Micro-Oasis"',
  description: 'Cómo recuperar la intimidad sin gastar un peso',
  benefit: '→ Reconectar sin gastar un peso',
  value: '$2.400'
}];
export function DeliverablesSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-20 md:py-28 bg-[#FFFFFF]" data-id="element-43">
      <div className="max-w-5xl mx-auto px-6" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-45">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2D2D] mb-12 text-center" data-id="element-46">
            Lo que vas a obtener:
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-47">
            {deliverables.map((item, index) => {
            const Icon = item.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} animate={isInView ? {
              opacity: 1,
              y: 0
            } : {
              opacity: 0,
              y: 20
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="bg-[#F0EDEB] rounded-xl p-6 border border-black/5 shadow-lg hover:border-[#722F37]/30 hover:shadow-[0_0_20px_rgba(114,47,55,0.1)] transition-all group flex flex-col" data-id="element-48">
                  <div className="w-14 h-14 bg-[#722F37]/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#722F37]/20 transition-colors" data-id="element-49">
                    <Icon className="w-8 h-8 text-[#722F37]" data-id="element-50" />
                  </div>
                  <h3 className="text-lg font-bold text-[#2D2D2D] mb-2" data-id="element-51">
                    {item.title}
                  </h3>
                  <p className="text-[#6B7280] mb-3 text-sm" data-id="element-52">
                    {item.description}
                  </p>
                  <p className="text-[#059669] font-semibold text-sm mb-6" data-id="element-53">
                    {item.benefit}
                  </p>
                  <div className="mt-auto pt-4 border-t border-black/5" data-id="element-54">
                    <span className="text-xs text-[#6B7280] uppercase tracking-wider" data-id="element-55">
                      Valor individual:{' '}
                    </span>
                    <span className="text-[#2D2D2D] font-semibold line-through opacity-50" data-id="element-56">
                      {item.value}
                    </span>
                  </div>
                </motion.div>;
          })}
          </div>

          <div className="bg-[#F0EDEB] p-6 rounded-xl border border-[#722F37]/20 text-center max-w-md mx-auto" data-id="element-57">
            <p className="text-[#6B7280] mb-2" data-id="element-58">Valor total real:</p>
            <p className="text-3xl font-bold text-[#2D2D2D] line-through decoration-[#8B1A2B] decoration-2 mb-2" data-id="element-59">
              $14.900
            </p>
            <p className="text-[#722F37] font-bold text-xl" data-id="element-60">
              Hoy te llevas todo por solo $8.900
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}